import { render, staticRenderFns } from "./AvisoModal.vue?vue&type=template&id=c1ec8eac&scoped=true&"
import script from "./AvisoModal.vue?vue&type=script&lang=js&"
export * from "./AvisoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ec8eac",
  null
  
)

export default component.exports